export default __webpack_public_path__ + "static/media/logo-light-tsul.b0f0dcb1.png";